/**
 * Status als 3px breiter linker Rand, nie flächige Einfärbung
 * (`design-system`, „Farbe ist nie das einzige Signal"). `status.value`
 * entscheidet hier nichts Fachliches — die Zeile wird ohnehin genauso
 * gerendert, nur eingefärbt. Der Wert selbst kommt vollständig vom Server
 * (I9); dieses Modul bildet keinen neuen Status, es wählt nur eine Klasse.
 *
 * Geteilt zwischen `OpenItemsList` (`open-items`) und `ChargesList`
 * (`charges`) — beide in derselben Domäne, keine Duplikation über eine
 * Feature-Grenze hinweg nötig.
 */

const STATUS_BORDER: Record<string, string> = {
  open: 'border-l-status-open',
  partial: 'border-l-status-partial',
  settled: 'border-l-status-paid',
  overpaid: 'border-l-status-paid',
}

export function statusBorderClass(value: string): string {
  return `border-l-status ${STATUS_BORDER[value] ?? 'border-l-status-open'}`
}
